import userProfileHof from 'root/src/client/logic/app/util/userProfileHof'

export default userProfileHof('introProjectCreated')
